import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';

export interface ConfirmationOverlayEvent {
  visible: boolean;
  message: string;
}

export const SHOW_TIME = 3000;

@Injectable({
  providedIn: 'root',
})
export class ConfirmationOverlayService {
  private eventSubject = new Subject<ConfirmationOverlayEvent>();

  get events() {
    return this.eventSubject.pipe(
      publishReplay(1),
      refCount()
    );
  }

  show(message: string, showTime = SHOW_TIME) {
    this.eventSubject.next(<ConfirmationOverlayEvent>{ visible: true, message });
    setTimeout(() => {
      this.eventSubject.next(<ConfirmationOverlayEvent>{ visible: false });
    }, showTime);
  }
}
